import {
  CartItemType,
  PerBookingFieldTypeInBookingFields,
} from "@mono/essentials/entities/cart/types"
import { OrderItemType } from "@mono/essentials/types/OrderTypes"

export const getBookingFieldsInfoOfCartItem = ({
  cartItem,
  orderItem,
  perBookingFieldsDetails,
}: {
  cartItem?: CartItemType
  orderItem?: OrderItemType
  perBookingFieldsDetails?: PerBookingFieldTypeInBookingFields[]
}) => {
  if (
    (typeof cartItem === "undefined" && typeof orderItem === "undefined") ||
    perBookingFieldsDetails?.length === 0
  )
    return []
  const perBookingFields: Record<string, boolean | string | string[] | number> = {}
  perBookingFieldsDetails
    ?.filter((pf) => pf.cart_item_id === cartItem?.id || pf.order_item_id === orderItem?.id)
    .forEach((bookingField) => {
      perBookingFields[bookingField.field_dump.product_field.field.name] = bookingField.value
        ? bookingField.field_dump.product_field.field.type === "checkbox"
          ? Array.isArray(bookingField.value)
            ? bookingField.value
            : JSON.parse(bookingField.value as string)
          : bookingField.value
        : bookingField.field_dump.product_field.field.type === "checkbox"
          ? []
          : ""
      perBookingFields[`${bookingField.field_dump.product_field.field.name}_id`] =
        bookingField.field_dump.product_field.id ?? ""
      if (orderItem)
        perBookingFields[
          `${bookingField.field_dump.product_field.field.name}_order_item_field_id`
        ] = bookingField?.id ?? ""
    })
  return Object.keys(perBookingFields).length ? [perBookingFields] : []
}
